/**
 * 船員基本情報
 * @typedef {Object} CrewBasicInfo
 *
 * @property {string} id - 船員ID
 * @property {string} name - 船員名
 * @property {string} name_kana - 船員名（カナ）
 * @property {string} employment_status - 社員区分(仮実装)
 * @property {Array<dynamic>} affiliated_companies - 所属企業
 * @property {Array<dynamic>} available_roles - 辞令職と執職可能役職
 * @property {string} highest_rank_name - 対応可能な最上位役職(仮実装)
 * @property {string} joining_date - 入社日
 * @property {string} employee_number - 社員番号
 * @property {string} union_member - 組合員該当
 * @property {string} email_address - メールアドレス
 * @property {string} phone_number - 電話番号
 * @property {string} birth_date - 生年月日
 * @property {string} postal_code - 住所（郵便番号）
 * @property {string} prefecture - 住所（都道府県）
 * @property {string} address - 住所（市区町村以下）
 * @property {string} retirement_date - 退職日
 * @property {string} memo - 備考
 */
export class CrewBasicInfo {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.name_kana = data.name_kana;
    this.employment_status = data.employment_status;
    this.affiliated_companies = data.affiliated_companies;
    this.available_roles = data.available_roles;
    this.highest_rank_name = data.highest_rank_name;
    this.joining_date = data.joining_date;
    this.employee_number = data.employee_number;
    this.union_member = data.union_member;
    this.email_address = data.email_address;
    this.phone_number = data.phone_number;
    this.birth_date = data.birth_date;
    this.postal_code = data.postal_code;
    this.prefecture = data.prefecture;
    this.address = data.address;
    this.retirement_date = data.retirement_date;
    this.memo = data.memo;
  }
}
// id id
// 氏名 name
// カナ name_kana
// 社員区分 employment_status
// 所属企業 affiliated_company
// 辞令職 appointment_role_name
// 対応可能な最上位役職 highest_rank_name
// 入社日 joining_date
// 社員番号 employee_number
// 組合員該当 union_member
// メールアドレス email_address
// 電話番号 phone_number
// 生年月日 birth_date
// 住所（郵便番号） postal_code
// 住所（都道府県） prefecture
// 住所（市区町村以下） address
// 退職日 retirement_date
// 備考 memo
/*
"crew_available_roles": [
  {
    "end_date": "2025-12-31",
    "enterprise_crew_role_id": 123,
    "id": 12345,
    "is_appointed": true,
    "start_date": "2023-01-01"
  }
],
*/
